import React from 'react';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';
import GasConsumingEquipmentDetailsModal from '@/pages/PersonalAccountDetails/views/MeteringNode/components/GasConsumingEquipmentDetailsModal';
import type { AppRouteObject } from '@/routeTypes';

const Information = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/Information'),
);
const MeteringNode = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/MeteringNode'),
);
const Consumption = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/Consumption'),
);
const MeterReadings = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/MeterReadings'),
);
const MeterReadingsDetails = React.lazy(
  () =>
    import('@/pages/PersonalAccountDetails/views/MeterReadings/components/MeterReadingsDetails'),
);
const DocumentsAndFiles = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/DocumentsAndFiles'),
);
const PersonalAccountActs = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/Acts'),
);
const Ledger = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/Ledger'),
);
const Payment = React.lazy(
  () => import('@/pages/PersonalAccountDetails/views/Payment'),
);
const MeteringNodeSealDetailsModal = React.lazy(
  () =>
    import('@/pages/PersonalAccountDetails/views/MeteringNodeSealDetailsModal'),
);

// The index tab is not guarded here: PersonalAccountDetails opens the first allowed tab instead.
export const personalAccountDetailsRoutes: AppRouteObject[] = [
  {
    index: true,
    element: <Information />,
  },
  {
    path: Pages.METERING_NODE,
    element: <MeteringNode />,
    handle: { permissions: UserPermissions.PersonalAccountsMeteringNodeRead },
    children: [
      {
        path: `${Pages.GAS_CONSUMING_EQUIPMENT}/:gasConsumingEquipmentId`,
        element: <GasConsumingEquipmentDetailsModal />,
      },
      {
        path: `seals/:sealId`,
        element: <MeteringNodeSealDetailsModal />,
      },
    ],
  },
  {
    path: Pages.CONSUMPTION,
    element: <Consumption />,
    handle: { permissions: UserPermissions.PersonalAccountsConsumptionRead },
  },
  {
    path: Pages.METER_READINGS,
    element: <MeterReadings />,
    handle: { permissions: UserPermissions.PersonalAccountsMeterReadingsRead },
    children: [
      {
        path: ':id',
        element: <MeterReadingsDetails />,
      },
    ],
  },
  {
    path: Pages.DOCUMENTS_AND_FILES,
    element: <DocumentsAndFiles />,
    handle: {
      permissions: UserPermissions.PersonalAccountsDocumentsAndFilesRead,
    },
  },
  {
    path: Pages.METERING_POINT_ACT,
    element: <PersonalAccountActs />,
    handle: { permissions: UserPermissions.PersonalAccountsActsRead },
  },
  {
    path: Pages.LEDGER,
    element: <Ledger />,
  },
  {
    path: Pages.PAYMENT,
    element: <Payment />,
  },
];
